import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LangService } from '../../services/lang.service';
import { Guide } from '../../structure/types/guide.class';

@Component({
    selector: 'app-guide-section',
    templateUrl: './guide-section.component.html',
    styleUrls: ['./guide-section.component.scss'],
    standalone: false
})
export class GuideSectionComponent {
    /** Heading text shown above the cards. Omit to hide the heading. */
    @Input() title: string = '';
    /** Full list of guides to display. Nothing renders if empty. */
    @Input() guides: Guide[] = [];
    /** Route for the "See more" link/card. Omit to hide see-more entirely. */
    @Input() seeMoreRoute: string = '';
    /** Card variant forwarded to app-guide-card. */
    @Input() variant: 'default' | 'resume' | 'completed' = 'default';
    /** Max cards shown in the desktop grid. */
    @Input() desktopLimit: number = 3;
    /**
     * Max cards shown in the mobile swiper.
     * Pass 0 to show all (e.g. for recommended where every guide is shown).
     */
    @Input() mobileLimit: number = 4;
    /**
     * When true, the see-more link/card is always shown if seeMoreRoute is set,
     * regardless of how many guides there are.
     * Use this for sections like Recommended where you always want the "see all" link.
     */
    @Input() alwaysSeeMore: boolean = false;

    @Output() guideClick = new EventEmitter<Guide>();

    constructor(public lang: LangService) {}

    get mobileGuides(): Guide[] {
        return this.mobileLimit > 0 ? this.guides.slice(0, this.mobileLimit) : this.guides;
    }

    get desktopGuides(): Guide[] {
        return this.guides.slice(0, this.desktopLimit);
    }

    get showMobileSeeMore(): boolean {
        if (!this.seeMoreRoute) return false;
        if (this.alwaysSeeMore) return true;
        return this.mobileLimit > 0 && this.guides.length > this.mobileLimit;
    }

    get showDesktopSeeMore(): boolean {
        if (!this.seeMoreRoute) return false;
        if (this.alwaysSeeMore) return true;
        return this.guides.length > this.desktopLimit;
    }

    trackByGuideId = (_: number, guide: Guide): number => guide.id;
}
